import React from 'react';

const Header = () => {
  return (
    <header>
      <h1>Inspired by #</h1>
    </header>
  );
};

export default Header;
